import { render, staticRenderFns } from "./threadDetail.vue?vue&type=template&id=2c97c4a9&"
import script from "./threadDetail.vue?vue&type=script&lang=js&"
export * from "./threadDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports